export const DEFINE_MODULE = {
  name: "lớp học",
  fields: "rooms"
}
